import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const supplierApi = createApi({
  reducerPath: "supplierApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getSuppliers: builder.query({
      query: (params) => ({
        url: "supplier/",
        params,
      }),
    }),
    getSupplierById: builder.query({
      query: (supplierId) => ({
        url: `supplier/${supplierId}`,
      }),
    }),
    createSupplier: builder.mutation({
      query: (newSupplier) => ({
        url: "supplier",
        method: "POST",
        body: newSupplier,
      }),
    }),
    updateSupplier: builder.mutation({
      query: ({ id, updatedSupplier }) => ({
        url: `supplier/${id}`,
        method: "PUT",
        body: updatedSupplier,
      }),
    }),
    deleteSupplier: builder.mutation({
      query: (id) => ({
        url: `supplier/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useGetSupplierByIdQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = supplierApi;
